import type { EnemyElite, EnemyKind } from './enemies'
import type { MapId } from './maps'

export interface EliteModifierDefinition {
  readonly id: EnemyElite
  readonly name: string
  readonly glyph: string
  readonly color: number
  readonly cssColor: string
  readonly description: string
  readonly hpMultiplier: number
  readonly speedMultiplier: number
  readonly armorBonus: number
  readonly regenPerSecond: number
  readonly coreDamageMultiplier: number
  readonly rewardMultiplier: number
}

export const ELITE_MODIFIERS: Record<EnemyElite, EliteModifierDefinition> = {
  FIREWALL: {
    id: 'FIREWALL', name: 'FIREWALL', glyph: '⬢', color: 0xffb347, cssColor: '#ffb347',
    description: 'Fortified shell: +45% integrity and +14% armor.',
    hpMultiplier: 1.45, speedMultiplier: 0.94, armorBonus: 0.14, regenPerSecond: 0,
    coreDamageMultiplier: 1.15, rewardMultiplier: 1.8,
  },
  FLASH_STEP: {
    id: 'FLASH_STEP', name: 'FLASH STEP', glyph: '↯', color: 0xff4fd8, cssColor: '#ff4fd8',
    description: 'Burst movement: +32% speed with an additional pulse surge.',
    hpMultiplier: 1.12, speedMultiplier: 1.32, armorBonus: 0, regenPerSecond: 0,
    coreDamageMultiplier: 1.1, rewardMultiplier: 1.65,
  },
  SIPHON: {
    id: 'SIPHON', name: 'SIPHON', glyph: '✚', color: 0x47f2a5, cssColor: '#47f2a5',
    description: 'Repairs 2.5% integrity per second and inflicts 45% more Core damage.',
    hpMultiplier: 1.22, speedMultiplier: 1, armorBonus: 0.04, regenPerSecond: 0.025,
    coreDamageMultiplier: 1.45, rewardMultiplier: 1.75,
  },
}

export const ELITE_IDS = Object.keys(ELITE_MODIFIERS) as EnemyElite[]

export interface EliteSpawnRule {
  readonly kind: EnemyKind
  readonly elite: EnemyElite
  readonly count: number
}

type EliteSchedule = readonly (readonly EliteSpawnRule[])[]

export const ELITE_SCHEDULES: Record<MapId, EliteSchedule> = {
  GENESIS_NETWORK: [
    [],
    [],
    [{ kind: 'FUD_BOT', elite: 'SIPHON', count: 1 }],
    [{ kind: 'LIQUIDATOR', elite: 'FIREWALL', count: 1 }],
    [{ kind: 'PAPER_HAND', elite: 'FLASH_STEP', count: 2 }, { kind: 'LIQUIDATOR', elite: 'FIREWALL', count: 1 }, { kind: 'FUD_BOT', elite: 'SIPHON', count: 1 }],
  ],
  NEON_EXCHANGE: [
    [],
    [{ kind: 'PAPER_HAND', elite: 'FLASH_STEP', count: 1 }],
    [{ kind: 'PAPER_HAND', elite: 'FLASH_STEP', count: 2 }, { kind: 'FUD_BOT', elite: 'SIPHON', count: 1 }],
    [{ kind: 'PAPER_HAND', elite: 'FLASH_STEP', count: 2 }, { kind: 'LIQUIDATOR', elite: 'FIREWALL', count: 1 }],
    [{ kind: 'PAPER_HAND', elite: 'FLASH_STEP', count: 3 }, { kind: 'FUD_BOT', elite: 'SIPHON', count: 1 }, { kind: 'LIQUIDATOR', elite: 'FIREWALL', count: 1 }],
  ],
  VALIDATOR_HEIGHTS: [
    [],
    [{ kind: 'BOT', elite: 'FIREWALL', count: 1 }],
    [{ kind: 'FUD_BOT', elite: 'SIPHON', count: 1 }, { kind: 'PAPER_HAND', elite: 'FLASH_STEP', count: 1 }],
    [{ kind: 'LIQUIDATOR', elite: 'FIREWALL', count: 2 }],
    [{ kind: 'LIQUIDATOR', elite: 'FIREWALL', count: 2 }, { kind: 'FUD_BOT', elite: 'SIPHON', count: 1 }, { kind: 'PAPER_HAND', elite: 'FLASH_STEP', count: 1 }],
  ],
}
